import React, { useEffect, useState } from 'react'
import AdminMenu from '../../../Components/Admin/AdminMenu/AdminMenu'
 
import { handleError } from '../ErrorModule/ErrorModule'
import { useError } from '../../../Components/Admin/ErrorRequest/ErrorProvider'
import { useLocation } from 'react-router-dom'
import { clientData } from './AdminMenuLogic/AdminMenuLogic'

const AdminMenuModule = ({myTarif, dataClient}) => {
  const { showError } = useError();
  const location = useLocation()
  const [clientsData, setClientsData] = useState()
  const getClientData = () => {
    location.pathname !== '/notNetwork' &&
    clientData().then(res => {
      setClientsData(res.data)
    }).catch(err => {
      showError(err.message)
    })
  }
  useEffect(()=> { 
    getClientData()
  }, [])
  return (
    <div>
      <AdminMenu clientsData={location.pathname === '/notNetwork' ? dataClient : clientsData} myTarif={myTarif?.name}/>
    </div>
  )
}

export default AdminMenuModule
